// @flow
export const arrayToObject = (array: Array<number>) => {
  const obj = {};
  array.forEach(value => {
    obj[value] = value;
  });
  return obj;
};



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/shared/utils/arrayToObject.js